import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar      from './components/Navbar';
import Hero        from './components/Hero';
import About       from './components/About';
import Services    from './components/Services';
import Projects    from './components/Projects';
import WhyInvest   from './components/WhyInvest';
import Blog        from './components/Blog';
import Contact     from './components/Contact';
import Footer      from './components/Footer';
import Presentation from './pages/Presentation';

function MainSite() {
  return (
    <div className="font-sans">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Projects />
      <WhyInvest />
      <Blog />
      <Contact />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/presentacion" element={<Presentation />} />
      </Routes>
    </BrowserRouter>
  );
}
